// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file gateway/v1/device.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination, PaginationMetadata } from "./core_pb";
import { file_gateway_v1_core } from "./core_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gateway/v1/device.proto.
 */
export const file_gateway_v1_device: GenFile = /*@__PURE__*/
  fileDesc("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", [file_gateway_v1_core, file_google_protobuf_timestamp]);

/**
 * Device message represents a physical device in the system.
 *
 * @generated from message gateway.v1.Device
 */
export type Device = Message<"gateway.v1.Device"> & {
  /**
   * uuid is the unique identifier for the device, generated as a UUID string.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name of the device.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * type of the device (weather station or geolocation).
   *
   * @generated from field: gateway.v1.DeviceType type = 3;
   */
  type: DeviceType;

  /**
   * created_at timestamp when the device was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * updated_at timestamp when the device was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 0);

/**
 * CreateDeviceRequest is the request message for creating a new device.
 *
 * @generated from message gateway.v1.CreateDeviceRequest
 */
export type CreateDeviceRequest = Message<"gateway.v1.CreateDeviceRequest"> & {
  /**
   * name is the name of the device to be created, which can be used to identify the device in a human-readable way.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * type of the device, which indicates whether the device is a weather station or a geolocation device.
   *
   * @generated from field: gateway.v1.DeviceType type = 2;
   */
  type: DeviceType;
};

/**
 * Describes the message gateway.v1.CreateDeviceRequest.
 * Use `create(CreateDeviceRequestSchema)` to create a new message.
 */
export const CreateDeviceRequestSchema: GenMessage<CreateDeviceRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 1);

/**
 * CreateDeviceResponse is the response message for the CreateDevice RPC, containing the details of the newly created device.
 *
 * @generated from message gateway.v1.CreateDeviceResponse
 */
export type CreateDeviceResponse = Message<"gateway.v1.CreateDeviceResponse"> & {
  /**
   * device is the newly created device.
   *
   * @generated from field: gateway.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message gateway.v1.CreateDeviceResponse.
 * Use `create(CreateDeviceResponseSchema)` to create a new message.
 */
export const CreateDeviceResponseSchema: GenMessage<CreateDeviceResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 2);

/**
 * GetDeviceByUuidRequest is the request message for retrieving a device by its UUID.
 *
 * @generated from message gateway.v1.GetDeviceByUuidRequest
 */
export type GetDeviceByUuidRequest = Message<"gateway.v1.GetDeviceByUuidRequest"> & {
  /**
   * uuid is the unique identifier of the device to retrieve.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.GetDeviceByUuidRequest.
 * Use `create(GetDeviceByUuidRequestSchema)` to create a new message.
 */
export const GetDeviceByUuidRequestSchema: GenMessage<GetDeviceByUuidRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 3);

/**
 * GetDeviceByUuidResponse is the response message for the GetDeviceByUuid RPC.
 *
 * @generated from message gateway.v1.GetDeviceByUuidResponse
 */
export type GetDeviceByUuidResponse = Message<"gateway.v1.GetDeviceByUuidResponse"> & {
  /**
   * device is the device retrieved based on the provided UUID.
   *
   * @generated from field: gateway.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceByUuidResponse.
 * Use `create(GetDeviceByUuidResponseSchema)` to create a new message.
 */
export const GetDeviceByUuidResponseSchema: GenMessage<GetDeviceByUuidResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 4);

/**
 * GetDevicesByNameRequest is the request message for searching devices by name.
 *
 * @generated from message gateway.v1.GetDevicesByNameRequest
 */
export type GetDevicesByNameRequest = Message<"gateway.v1.GetDevicesByNameRequest"> & {
  /**
   * name is the search term matched against device names.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * pagination contains the pagination parameters for retrieving a specific page of matching devices.
   *
   * @generated from field: gateway.v1.Pagination pagination = 2;
   */
  pagination?: Pagination | undefined;

  /**
   * type optionally restricts the search to one device type. DEVICE_TYPE_UNSPECIFIED (the default) matches every type.
   *
   * @generated from field: gateway.v1.DeviceType type = 3;
   */
  type: DeviceType;
};

/**
 * Describes the message gateway.v1.GetDevicesByNameRequest.
 * Use `create(GetDevicesByNameRequestSchema)` to create a new message.
 */
export const GetDevicesByNameRequestSchema: GenMessage<GetDevicesByNameRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 5);

/**
 * GetDevicesByNameResponse is the response message for the GetDevicesByName RPC.
 *
 * @generated from message gateway.v1.GetDevicesByNameResponse
 */
export type GetDevicesByNameResponse = Message<"gateway.v1.GetDevicesByNameResponse"> & {
  /**
   * devices is the list of devices whose name matches the provided search term for the requested page.
   *
   * @generated from field: repeated gateway.v1.Device devices = 1;
   */
  devices: Device[];

  /**
   * metadata contains additional information about the pagination, such as total count of matching devices and the pagination parameters used.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetDevicesByNameResponse.
 * Use `create(GetDevicesByNameResponseSchema)` to create a new message.
 */
export const GetDevicesByNameResponseSchema: GenMessage<GetDevicesByNameResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 6);

/**
 * GetDeviceListByPageRequest is the request message for retrieving a paginated list of devices.
 *
 * @generated from message gateway.v1.GetDeviceListByPageRequest
 */
export type GetDeviceListByPageRequest = Message<"gateway.v1.GetDeviceListByPageRequest"> & {
  /**
   * pagination contains the pagination parameters for retrieving a specific page of devices.
   *
   * @generated from field: gateway.v1.Pagination pagination = 1;
   */
  pagination?: Pagination | undefined;

  /**
   * type optionally restricts the list to one device type. DEVICE_TYPE_UNSPECIFIED (the default) lists every type.
   *
   * @generated from field: gateway.v1.DeviceType type = 2;
   */
  type: DeviceType;
};

/**
 * Describes the message gateway.v1.GetDeviceListByPageRequest.
 * Use `create(GetDeviceListByPageRequestSchema)` to create a new message.
 */
export const GetDeviceListByPageRequestSchema: GenMessage<GetDeviceListByPageRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 7);

/**
 * GetDeviceListByPageResponse is the response message for the GetDeviceListByPage. It contains a list of devices for the requested page.
 *
 * @generated from message gateway.v1.GetDeviceListByPageResponse
 */
export type GetDeviceListByPageResponse = Message<"gateway.v1.GetDeviceListByPageResponse"> & {
  /**
   * devices is the list of devices retrieved for the requested page based on the pagination parameters provided in the request.
   *
   * @generated from field: repeated gateway.v1.Device devices = 1;
   */
  devices: Device[];

  /**
   * metadata contains additional information about the pagination, such as total count of devices and the pagination parameters used.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetDeviceListByPageResponse.
 * Use `create(GetDeviceListByPageResponseSchema)` to create a new message.
 */
export const GetDeviceListByPageResponseSchema: GenMessage<GetDeviceListByPageResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 8);

/**
 * UpdateDeviceRequest is the request message for updating an existing device. It contains the updated details of the device, including its UUID to identify which device to update.
 *
 * @generated from message gateway.v1.UpdateDeviceRequest
 */
export type UpdateDeviceRequest = Message<"gateway.v1.UpdateDeviceRequest"> & {
  /**
   * uuid is the unique identifier of the device to update.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name is the new name for the device.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * type of the device, which indicates whether the device is a weather station or a geolocation device.
   *
   * @generated from field: gateway.v1.DeviceType type = 3;
   */
  type: DeviceType;
};

/**
 * Describes the message gateway.v1.UpdateDeviceRequest.
 * Use `create(UpdateDeviceRequestSchema)` to create a new message.
 */
export const UpdateDeviceRequestSchema: GenMessage<UpdateDeviceRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 9);

/**
 * UpdateDeviceResponse is the response message for the UpdateDevice RPC, containing the details of the updated device.
 *
 * @generated from message gateway.v1.UpdateDeviceResponse
 */
export type UpdateDeviceResponse = Message<"gateway.v1.UpdateDeviceResponse"> & {
  /**
   * device is the updated device after applying the changes specified in the UpdateDeviceRequest.
   *
   * @generated from field: gateway.v1.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message gateway.v1.UpdateDeviceResponse.
 * Use `create(UpdateDeviceResponseSchema)` to create a new message.
 */
export const UpdateDeviceResponseSchema: GenMessage<UpdateDeviceResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 10);

/**
 * DeleteDeviceRequest is the request message for deleting a device based on its UUID.
 *
 * @generated from message gateway.v1.DeleteDeviceRequest
 */
export type DeleteDeviceRequest = Message<"gateway.v1.DeleteDeviceRequest"> & {
  /**
   * uuid is the unique identifier of the device to delete.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.DeleteDeviceRequest.
 * Use `create(DeleteDeviceRequestSchema)` to create a new message.
 */
export const DeleteDeviceRequestSchema: GenMessage<DeleteDeviceRequest> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 11);

/**
 * DeleteDeviceResponse is the response message for the DeleteDevice RPC, indicating whether the deletion was successful.
 *
 * @generated from message gateway.v1.DeleteDeviceResponse
 */
export type DeleteDeviceResponse = Message<"gateway.v1.DeleteDeviceResponse"> & {
};

/**
 * Describes the message gateway.v1.DeleteDeviceResponse.
 * Use `create(DeleteDeviceResponseSchema)` to create a new message.
 */
export const DeleteDeviceResponseSchema: GenMessage<DeleteDeviceResponse> = /*@__PURE__*/
  messageDesc(file_gateway_v1_device, 12);

/**
 * Device types
 *
 * @generated from enum gateway.v1.DeviceType
 */
export enum DeviceType {
  /**
   * Unspecified device type, used as a default value.
   *
   * @generated from enum value: DEVICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Weatherstation device type, representing weatherstation devices.
   *
   * @generated from enum value: DEVICE_TYPE_WEATHER = 1;
   */
  WEATHER = 1,

  /**
   * Geolocation device type, representing devices that provide location information.
   *
   * @generated from enum value: DEVICE_TYPE_GEO = 2;
   */
  GEO = 2,
}

/**
 * Describes the enum gateway.v1.DeviceType.
 */
export const DeviceTypeSchema: GenEnum<DeviceType> = /*@__PURE__*/
  enumDesc(file_gateway_v1_device, 0);

/**
 * DeviceService defines the gRPC service for managing devices.
 *
 * -------------------------------------------------------------------------
 * Device entity CRUD operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.DeviceService
 */
export const DeviceService: GenService<{
  /**
   * CreateDevice creates a new device in the system.
   *
   * @generated from rpc gateway.v1.DeviceService.CreateDevice
   */
  createDevice: {
    methodKind: "unary";
    input: typeof CreateDeviceRequestSchema;
    output: typeof CreateDeviceResponseSchema;
  },
  /**
   * GetDeviceByUuid retrieves a device by its unique identifier (UUID).
   *
   * @generated from rpc gateway.v1.DeviceService.GetDeviceByUuid
   */
  getDeviceByUuid: {
    methodKind: "unary";
    input: typeof GetDeviceByUuidRequestSchema;
    output: typeof GetDeviceByUuidResponseSchema;
  },
  /**
   * GetDevicesByName retrieves devices whose name matches the given search term.
   *
   * @generated from rpc gateway.v1.DeviceService.GetDevicesByName
   */
  getDevicesByName: {
    methodKind: "unary";
    input: typeof GetDevicesByNameRequestSchema;
    output: typeof GetDevicesByNameResponseSchema;
  },
  /**
   * GetDeviceListByPage retrieves a paginated list of all devices.
   *
   * @generated from rpc gateway.v1.DeviceService.GetDeviceListByPage
   */
  getDeviceListByPage: {
    methodKind: "unary";
    input: typeof GetDeviceListByPageRequestSchema;
    output: typeof GetDeviceListByPageResponseSchema;
  },
  /**
   * UpdateDevice updates the details of an existing device identified by its UUID.
   *
   * @generated from rpc gateway.v1.DeviceService.UpdateDevice
   */
  updateDevice: {
    methodKind: "unary";
    input: typeof UpdateDeviceRequestSchema;
    output: typeof UpdateDeviceResponseSchema;
  },
  /**
   * DeleteDevice removes a device from the system based on its UUID.
   *
   * @generated from rpc gateway.v1.DeviceService.DeleteDevice
   */
  deleteDevice: {
    methodKind: "unary";
    input: typeof DeleteDeviceRequestSchema;
    output: typeof DeleteDeviceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gateway_v1_device, 0);

